/** Go-live checklist calls. Shapes copied from workers/api/src/golive (checks.ts, routes.ts). */
import type { ApiClient } from "./client";

export type GoliveState = "ok" | "ticked" | "red" | "not_started";
export interface TerminalFacts { id: string; label: string | null; unmapped: number[]; reserved: number[] }
export interface GoliveItem {
  key: string;
  label: string;
  required: boolean;
  manual: boolean;
  /** May a person tick it by hand? Required automatic items cannot be. */
  tickable: boolean;
  state: GoliveState;
  detail: string;
  fix: { label: string; path: string };
  tick: { reason: string; by: string; at: number } | null;
  data?: { terminals?: TerminalFacts[] };
}
export interface GoliveChecklist { items: GoliveItem[]; blocking: string[]; ready: boolean; liveAt: number | null; liveBy: string | null }

export const getChecklist = (c: ApiClient) => c.get<{ checklist: GoliveChecklist }>("/golive/checklist").then((r) => r.checklist);
export const tickItem = (c: ApiClient, key: string, reason: string) =>
  c.post<{ checklist: GoliveChecklist }>(`/golive/items/${encodeURIComponent(key)}/tick`, { reason }).then((r) => r.checklist);
